import React from 'react';
import Layout from '../Layout';
import { Container, Box, Grid } from '@material-ui/core';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import CameraIcon from '@material-ui/icons/Camera';
import BuildIcon from '@material-ui/icons/Build';
import SubjectIcon from '@material-ui/icons/Subject';
import TimelineIcon from '@material-ui/icons/Timeline';
import PostAddIcon from '@material-ui/icons/PostAdd';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';
import "./Breakdown.css";
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';

const AttendBreakdown = () => {
    const location = useLocation();
    const pathname = location.pathname.split('/');
    console.log("in attend", pathname)
    const breakdown_id = pathname[2]
    const asset_id = pathname[3]
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Current Breakdowns', href: '/breakdown-management/current-breakdowns' },
    ];

    const navigate = useNavigate();

    const handler = (route) => {
        console.log("check route", route)
        navigate(route)
    }
    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Attend Breakdown
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Attend Breakdown" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={5} className='PM'
                            onClick={() => handler(`/attend-breakdown/breakdown-history/${asset_id}`)}
                        >
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <TimelineIcon />
                                    <p className='text'>
                                        Breakdown History
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler("/attend-breakdown/camera")}>
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <CameraIcon />
                                    <p className='text'>
                                        Take Pictures
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler(`/attend-breakdown/add-observation/${breakdown_id}`)}>
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <PostAddIcon />
                                    <p className='text'>
                                        Add Observation
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler()}>
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <SubjectIcon />
                                    <p className='text'>
                                        Manual
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler(`/attend-breakdown/spare-list`)}>
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <SettingsInputComponentIcon />
                                    <p className='text'>
                                        Spare List                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5} onClick={() => handler()}>
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <BuildIcon />
                                    <p className='text'>
                                        Tool List                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                        <Grid item className='PM' xs={12} sm={5}
                            onClick={() => handler(`/attend-breakdown/approver-list/${asset_id}/${breakdown_id}`)}
                        >
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <ThumbUpIcon />
                                    <p className='text'>
                                        Send for Approval                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Layout>
    );
};

export default AttendBreakdown;
